import { environment } from 'src/environments/environment';

export class User {
  id: string;
  name: string;
  email: string;
  image?: string;
  status?: string;
  accountdemo: string;
  accountreal: string;
  generationid: number;

  constructor(data?: Partial<User>) {
    if (data) {
      Object.assign(this, data);
    }
  }

  public get avatar(): string {
    return this.image && this.image != 'default.jpg'
      ? environment.s3Path + 'avatars/normal_' + this.image
      : 'https://ui-avatars.com/api/?name=' + this.name + '&background=random';
  }
}
